import type {PricedItemChange, PricedResourceType} from '../types/PricedItemChange';

export const createdItem = (
  resourceType: PricedResourceType,
  key: string,
  name: string,
  price: string
): PricedItemChange => ({
  resourceType,
  key,
  name,
  operation: 'created',
  before: null,
  after: price,
});
